<template>
	<div id="pageRoot">

		<!-- TEXTS ----------------------------------------------------------------------------------------------------->
		<p class="textBase" id="text01">
			Mira el dibujo y lee la palabra.
		</p>
		<p class="textBase" id="text02">
			Marca cada sílaba con un golpe.
		</p>
		<p class="textBase" id="text03">
			Pinta tantos círculos como sílabas<br>
			tiene la palabra.
		</p>

		<div class="basicItem01" id="doggieGroup">
			<img id="doggieSVG" src="/pages/img/sordo/svgPage63Dog.svg">
			<p class="textBase" id="text04">
				PERRO
			</p>
		</div>

		<label class="checkMarkContainer-a" style="left: 291px; top: 323.52px; position: absolute;">Una Sílaba
		<input type="checkbox" checked="checked">
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 355px; top: 323.52px; position: absolute;">Dos Sílabas
		<input type="checkbox" checked="checked">
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 418px; top: 323.52px; position: absolute;">Tres Sílabas
		<input type="checkbox">
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 481px; top: 323.52px; position: absolute;">Cuatro Sílabas
		<input type="checkbox">
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 544px; top: 323.52px; position: absolute;">Cinco Sílabas
		<input type="checkbox">
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 608px; top: 323.52px; position: absolute;">Seis Sílabas
		<input type="checkbox">
		<span class="checkmark-a"></span>
		</label>

		<div class="text-box-a pageElement hover-animation-a" id="textBoxGroup">
			<img id="textBoxSVG" src="/pages/img/sordo/svgPage68TextBox.svg">
			<p class="textBase" id="text05">
				Luego, en cada cartel,<br>
				escribe otra palabra que<br>
				tenga la misma cantidad<br>
				de sílabas.
			</p>
		</div>

		<p class="textBase" id="text06">
			MOTO
		</p>

		<div class="basicItem01" id="butterflyGroup">
			<img id="butterflySVG" src="/pages/img/sordo/svgPage64Butterfly.svg">
			<p class="textBase" id="text07">
				MARIPOSA
			</p>
		</div>

		<label class="checkMarkContainer-a" style="left: 291px; top: 539.12px; position: absolute;">Una Sílaba
		<input type="checkbox"
        ref="b1" 
        v-on:change="saveOption('radios', 'b1')" 
        :onload="loadOption('radios', 'b1')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 355px; top: 539.12px; position: absolute;">Dos Sílabas
		<input type="checkbox"
        ref="b2" 
        v-on:change="saveOption('radios', 'b2')" 
        :onload="loadOption('radios', 'b2')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 418px; top: 539.12px; position: absolute;">Tres Sílabas
		<input type="checkbox"
        ref="b3" 
        v-on:change="saveOption('radios', 'b3')" 
        :onload="loadOption('radios', 'b3')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 481px; top: 539.12px; position: absolute;">Cuatro Sílabas
		<input type="checkbox"
        ref="b4" 
        v-on:change="saveOption('radios', 'b4')" 
        :onload="loadOption('radios', 'b4')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 544px; top: 539.12px; position: absolute;">Cinco Sílabas
		<input type="checkbox"
        ref="b5" 
        v-on:change="saveOption('radios', 'b5')" 
        :onload="loadOption('radios', 'b5')"
        />
		<span class="checkmark-a"></span>
		</label>
		<label class="checkMarkContainer-a" style="left: 608px; top: 539.12px; position: absolute;">Seis Sílabas
		<input type="checkbox"
        ref="b6" 
        v-on:change="saveOption('radios', 'b6')" 
        :onload="loadOption('radios', 'b6')"
        />
		<span class="checkmark-a"></span>
		</label>

		<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=1 id="inputField01"/>

		<!-- TEXTS ----------------------------------------------------------------------------------------------------->

		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		<div class="pageSVG">
			<img src="/pages/img/sordo/svgPage68Background.svg" class="pageElement" style=" width: 100%; height: auto;">
		</div>
		<span class="footer-page footer-write"></span>
		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
	</div>
</template>
<style scoped>
.textBase 
{
margin:0px;
z-index: 3;
font-family: Open Sans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 24px;
line-height: 33px;
color: #000000;
}

#text01 
{
/* Mira el dibujo y lee la palabra. */
position: absolute;
left: 11.72%;
right: 40.53%;
top: 1.17%;
bottom: 94.66%;
}

#text02 
{
/* Marca cada sílaba con un golpe. */
position: absolute;
left: 11.72%;
right: 40.53%;
top: 6.12%;
bottom: 89.71%;
}

#text03 
{
/* Pinta tantos círculos como sílabas tiene la palabra. */
position: absolute;
left: 11.72%;
right: 50.39%;
top: 11.2%;
bottom: 84.64%;
}


#text04 
{
/* PERRO */
position: absolute;
width: 121px;
height: 51px;
left: 29px;
top: 106px;

font-size: 33px;
line-height: 45px;
text-align: center;
}

#text05 
{
/* Luego, en cada cartel, escribe otra palabra que tenga la misma cantidad de sílabas */
position: absolute;
width: 325px;
height: 164px;
left: 27px;
top: 10px;

font-weight: 600;
font-size: 26px;
line-height: 35px;
text-align: center;

color: #FFFFFF;
}

#text06 
{
/* MOTO */
position: absolute;
width: 133.98px;
height: 56.47px;
left: 765.84px;
top: 316.44px;

font-style: italic;
font-size: 33px;
line-height: 45px;
text-align: center;

color: #00A5A5;
}

#text07
{
/* MARIPOSA */
position: absolute;
width: 189px;
height: 45px;
left: 0px;
top: 143px;

font-size: 33px;
line-height: 45px;
text-align: center;
}

#inputField01
{
font-size: 28px;
position: absolute;
width: 156px;
height: 39px;
left: 746px;
top: 542px;
z-index: 3;
background-color: #D2D1C2;
}

#doggieGroup
{
position: absolute;
width: 157px;
height: 157px;
left: 63px;
top: 270px;
}
#doggieSVG 
{
position: absolute;
left: 0%;
top: 0%;
width: 100%;
height: auto;
}
#butterflyGroup
{
position: absolute;
width: 189px;
height: 188px;
left: 58px;
top: 465px;
}
#butterflySVG
{
position: absolute;
width: 132.86px;
height: auto;
left: 15.87%;
top: 0%;
}
#textBoxGroup
{
position: absolute;
width: 393.37px;
height: 302.28px;
left: 608px;
top: 26px;
}
#textBoxSVG 
{
position: absolute;
width: 393.37px;
height: 302.28px;
left: 0px;
top: 0px;
}
</style>
<script>
  export default {
    methods:{
      dbId(name, option){
        return `${this.$parent.pageID()}-${name}-${option}`
      },
      async loadOption(name, option) {
        var id = this.dbId(name, option);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[option].checked=value.option;

        console.log("option loaded: " + id + ", " + value.option);
      },
      saveOption(name, option) {
        var id = this.dbId(name, option);
        var value = this.$refs[option].checked;

        this.$db.options.put({
              id: id,
              option: value
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + value);
      }
    },
    mounted(){

    }
  }
</script>